import React from 'react'
import { usePreferences } from './hooks/usePreferences'
import { PreferencesContext } from './preferencesContextValue'

export const PreferencesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = usePreferences()
  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>
}
